var DISPUTES_CASES = function (accountId) {
    return "/v1/credit/billing/disputes/cases?cipher.accountId=".concat(accountId, "&accountIdType=guid");
};
var ADD_COMMENTS = function (caseId) {
    return "/v1/credit/billing/disputes/cases/".concat(caseId, "/notes");
};
export default {
    disputeCases: DISPUTES_CASES,
    createCases: '/v1/credit/billing/disputes/cases',
    questionnaire: '/v1/credit/billing/disputes/questionnaire',
    logout: '/v3/oauth2/logout',
    cancelDispute: '/v1/credit/billing/disputes/cancel',
    eligibility: '/v1/credit/billing/disputes/eligible-transactions',
    uploadFiles: '/v1/credit/billing/disputes/upload-files',
    addComments: ADD_COMMENTS
};
//# sourceMappingURL=apiEndpoints.js.map